/**
 * Shared calendar-year month-key/label helpers (dashboards round 3).
 *
 * Deliberately its own tiny, dependency-free module rather than added to
 * lib/forecastChartUtils.jsx: dashboardScopeWiring.test.js and
 * brosCostsPageMount.test.js both jest.mock('../../lib/forecastChartUtils')
 * with an incomplete export list (missing monthKeyToLabel/generateMonthAxis)
 * to keep those mount tests lightweight -- coupling the Bank Balance chart
 * builders (rendered under dashboardScopeWiring.test.js via DashboardPage)
 * to forecastChartUtils would hit `undefined` under that mock. Month names
 * are a true constant (unlike the entity/VAT-bucket lists CLAUDE.md's
 * "hand-maintained list drift" bug class warns about), so a single small
 * shared module carries no real drift risk either way -- this just avoids
 * duplicating the array/loop across files.
 */

var SHORT_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** Convert "YYYY-MM" to a short month label (e.g. "Jun"). */
export function monthKeyToLabel(monthKey) {
  var idx = parseInt(monthKey.split('-')[1], 10) - 1;
  return SHORT_MONTHS[idx] || monthKey;
}

/** "YYYY-01".."YYYY-12" for the given (or current) calendar year. */
export function calendarYearMonthKeys(year) {
  var y = year || new Date().getFullYear();
  var keys = [];
  for (var m = 1; m <= 12; m++) keys.push(y + '-' + String(m).padStart(2, '0'));
  return keys;
}
